import { NgModule } from '@angular/core';

import { PlayerComponent } from './player.component';
import { CommonModule } from '@angular/common';

@NgModule({
	imports: [CommonModule],
	exports: [PlayerComponent],
	declarations: [PlayerComponent],
	providers: [],
})
export class PlayerModule {}
